<template>
  <transition name="fade-up">
    <button
      v-show="visible"
      class="back-to-top"
      type="button"
      aria-label="回到顶部"
      @click="scrollToTop"
    >
      <i class="el-icon-arrow-up"></i>
    </button>
  </transition>
</template>

<script>
export default {
  name: 'BackToTop',
  data() {
    return {
      visible: false,
      threshold: 320
    }
  },
  mounted() {
    this.onScroll = () => {
      this.visible = window.scrollY > this.threshold
    }
    window.addEventListener('scroll', this.onScroll, { passive: true })
    this.onScroll()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.back-to-top {
  position: fixed;
  right: 28px;
  bottom: 32px;
  z-index: 900;
  width: 44px;
  height: 44px;
  border: none;
  border-radius: 50%;
  background: $primary-color;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  box-shadow: $shadow-md;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s, transform 0.2s, box-shadow 0.2s;

  &:hover {
    background: $primary-light;
    transform: translateY(-3px);
    box-shadow: $shadow-lg;
  }

  &:active {
    transform: translateY(-1px);
  }
}

.fade-up-enter-active,
.fade-up-leave-active {
  transition: opacity 0.25s, transform 0.25s;
}

.fade-up-enter,
.fade-up-leave-to {
  opacity: 0;
  transform: translateY(12px);
}

@media (max-width: 768px) {
  .back-to-top {
    right: 16px;
    bottom: 20px;
    width: 40px;
    height: 40px;
    font-size: 16px;
  }
}
</style>
